import * as yup from 'yup';
import { Rating, values } from '../enums';
import { ISuggestion, SuggestionSchema } from './ISuggestion';

export const ScaleRatingSchema = yup.object({
  rating: yup.mixed<Rating>().oneOf(values(Rating)).required(),
  note: yup
    .string()
    .nullable()
    .when('rating', {
      is: (val: Rating) => val === Rating.one || val === Rating.two,
      then: yup.string().required('description.required'),
      otherwise: yup.string().optional().nullable(),
    }),
});

export const OptionalScaleRatingSchema = yup.object({
  rating: yup
    .mixed<Rating>()
    .oneOf([...values(Rating), null, undefined])
    .notRequired()
    .nullable(),
  note: yup.string().notRequired().nullable(),
});

export type IScaleRating = {
  rating: Rating;
  note: string;
};

export const ScaleRatingSuggestionSchema = yup.object({
  zero: SuggestionSchema.nullable(),
  one: SuggestionSchema.nullable(),
  two: SuggestionSchema.nullable(),
  three: SuggestionSchema.nullable(),
});

export type IScaleRatingSuggestion = {
  zero: ISuggestion;
  one: ISuggestion;
  two: ISuggestion;
  three: ISuggestion;
};
